import { Box, Button, Chip, Container, Divider, Skeleton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./HomeSlider.css";
import { useNavigate } from "react-router-dom";
import JobShortCard from "./Latest Job/JobShortCard";
import { jobApi } from "../API/Api";
import { motion } from "framer-motion";
import { tokens } from "../../store/tokens";

const settings = {
  infinite: true,
  arrows: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  draggable: true,
  dots: false,
  autoplay: true,
  autoplaySpeed: 4000,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1, infinite: true, dots: true } },
    { breakpoint: 800, settings: { slidesToShow: 2, slidesToScroll: 1, initialSlide: 1 } },
    { breakpoint: 700, settings: { slidesToShow: 1, slidesToScroll: 1, initialSlide: 1 } },
    { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
};

const primaryButtonSx = {
  borderRadius: `${tokens.button.radius}px`,
  height: tokens.button.height.md,
  px: `${tokens.button.paddingX.md}px`,
  fontFamily: tokens.font.body,
  fontWeight: tokens.type.button.fontWeight,
  fontSize: tokens.button.fontSize.md,
  textTransform: tokens.type.button.textTransform,
  bgcolor: tokens.bg.brand,
  color: tokens.color.white,
  boxShadow: "none",
  transition: "background-color 0.2s ease",
  "&:hover": { bgcolor: tokens.bg.brandDark },
  width: { xs: "100%", sm: "auto" },
};

const HomePageJobs = () => {
  const navigate = useNavigate();
  const [jobListData, setJobListData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(jobApi)
      .then((res) => res.json())
      .then((result) => {
        setJobListData(result?.slice(0, 5));
        setLoading(false);
      })
      .catch((error) => console.log("JobApiError=> ", error));
  }, []);

  return (
    <Box sx={{ backgroundColor: tokens.bg.page, py: { xs: 5, md: 6 } }}>
      <Container>
        <Stack
          component={motion.div}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.5 }}
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Box>
            <Typography
              component="h2"
              sx={{
                fontFamily: tokens.font.heading,
                fontWeight: tokens.type.h2.fontWeight,
                fontSize: { xs: "1.6rem", md: tokens.type.h2.fontSize },
                color: tokens.textOn.light.primary,
              }}
            >
              Jobs
            </Typography>
            <Typography sx={{ fontFamily: tokens.font.body, fontWeight: 500, fontSize: tokens.type.body1.fontSize, color: tokens.textOn.light.secondary }}>
              Latest job posts curated for you
            </Typography>
          </Box>

          <Button
            component={motion.button}
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.97 }}
            variant="contained"
            onClick={() => navigate("/joblist")}
            sx={primaryButtonSx}
          >
            More jobs
          </Button>
        </Stack>

        <Divider sx={{ mb: 3, borderColor: tokens.color.line }} />

        {loading ? (
          <Slider {...settings}>
            {[1, 2, 3, 4].map((i) => (
              <Box key={i} sx={{ px: 1, pb: 4 }}>
                <Skeleton variant="rounded" height={180} sx={{ borderRadius: `${tokens.radius.md}px` }} />
              </Box>
            ))}
          </Slider>
        ) : (
          (jobListData[0]?.job_refer || jobListData[1]?.job_refer) && (
            <Slider {...settings}>
              {jobListData.map((job) => (
                <motion.div
                  key={job.job_refer}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.4 }}
                >
                  <Box sx={{ px: 1, pb: 4 }}>
                    <Stack spacing={1} sx={{ minHeight: 180 }}>
                      <JobShortCard jobData={job} />
                      {job.job_tags?.length > 0 && (
                        <Stack direction="row" spacing={1} flexWrap="wrap">
                          {job.job_tags.map((tag, i) => (
                            <Chip
                              key={i}
                              label={tag}
                              size="small"
                              sx={{
                                fontFamily: tokens.font.body,
                                backgroundColor: tokens.color.tealLight,
                                color: tokens.color.teal,
                                fontWeight: 600,
                                transition: "background-color 0.2s ease",
                                "&:hover": { backgroundColor: "rgba(15,138,141,0.2)" },
                              }}
                            />
                          ))}
                        </Stack>
                      )}
                    </Stack>
                  </Box>
                </motion.div>
              ))}
            </Slider>
          )
        )}
      </Container>
    </Box>
  );
};

export default HomePageJobs;